<template>
    <div class="country">
        <div class="search">
            <div class="search-input">
                <img class="search-icon" src="@/assets/images/openAccount/tax-info/search.png" />
                <input ref="searchInputRef" type="text" :placeholder="$t('CountryPopup.qsrdqgjzss')" v-model="inputVal" clearable />
                <img class="clear-icon" v-if="inputVal" @click="clearInputVal" src="@/assets/images/login/close.png" />
            </div>
            <span class="search-cancel" @click="clear">{{ $t('cancel') }}</span>
        </div>
        <div class="country-box" :class="{ searching: inputVal }">
            <van-index-bar ref="indexBarRef" :index-list="inputVal ? [] : showList.indexList" @select="handleIndexBarSelect">
                <template v-if="!inputVal">
                    <van-index-anchor :index="$t('CountryPopup.cydq')" />
                    <van-cell
                        v-for="(item, index) in showList.CommonlyList"
                        :key="index"
                        :title="item[`${showCountry}`]"
                        :value="item.areaCode"
                        @click="changeList(item)"
                    />
                </template>

                <div v-for="item in Object.keys(showList.dataList).sort((a, b) => a.localeCompare(b))" :key="item">
                    <van-index-anchor v-show="!inputVal" :index="item" />
                    <van-cell
                        v-for="(i_item, i_index) in showList.dataList[item].list"
                        :key="i_index"
                        :title="i_item[`${showCountry}`]"
                        :value="i_item.areaCode"
                        @click="changeList(i_item)"
                    >
                        <template #title>
                            <span v-html="handleHighlightText(i_item[showCountry])" />
                        </template>
                    </van-cell>
                </div>
            </van-index-bar>
        </div>
    </div>
</template>
<script>
import { countrys } from '@/config/country.js'
export default {
    data() {
        return {
            inputVal: '',

            indexList: [],
            CommonlyList: [], // 常用列表

            countrys,
        }
    },
    props: {
        select: {
            type: String,
            default: () => 'CHN',
        },
        Commonly: {
            // 设置常用的选择
            type: Array,
            default: () => ['CHN', 'HKG', 'MAC', 'TWN', 'USA', 'GBR', 'SGP'],
        },
    },
    computed: {
        showList() {
            const dataList = []
            const indexList = []
            const CommonlyList = []

            this.countrys.forEach(item => {
                if (this.inputVal) {
                    if (
                        item.zhCn.indexOf(this.inputVal) >= 0 ||
                        item.zhTw.indexOf(this.inputVal) >= 0 ||
                        item.en.toUpperCase().indexOf(this.inputVal.toUpperCase()) >= 0 ||
                        item.areaCode.indexOf(this.inputVal) >= 0
                    ) {
                        const Initials = item.countryCode.slice(0, 1) //首字母
                        // 正常的列表
                        if (indexList.indexOf(Initials) >= 0) {
                            dataList[Initials].list.push(item)
                        } else {
                            indexList.push(Initials)
                            dataList[Initials] = {
                                Initials,
                                list: [item],
                            }
                        }
                    }
                } else {
                    //没有输入任何内容
                    const Initials = item.countryCode.slice(0, 1) //首字母

                    // 添加常用地区
                    if (this.Commonly.indexOf(item.countryCode) >= 0) {
                        CommonlyList.push(item)
                    } else {
                        // 常用地区的国家不加入列表
                        // 正常的列表
                        if (dataList[Initials]) {
                            dataList[Initials].list.push(item)
                        } else {
                            indexList.push(Initials)
                            dataList[Initials] = {
                                Initials,
                                list: [item],
                            }
                        }
                    }
                }
            })

            indexList.sort((a, b) => a.localeCompare(b))

            return {
                indexList,
                dataList,
                CommonlyList,
            }
        },
        showCountry() {
            if (this.$i18n.locale == 'zhTc' || this.$i18n.locale == 'zhTw') {
                return 'zhTw'
            } else if (this.$i18n.locale == 'zhCn') {
                return 'zhCn'
            }
            return 'en'
        },
    },
    mounted() {
        // IOS UI兼容问题处理
        const inputRef = this.$refs.searchInputRef
        inputRef?.focus()
        inputRef?.blur()

        // console.log(countrys)
        // this.showList
    },
    methods: {
        clear() {
            this.inputVal = ''
            this.$emit('clear')
        },
        changeList(item) {
            this.$emit('change', item)
        },
        // 搜索内容高亮
        handleHighlightText(text = '') {
            return text.replace(this.inputVal, `<span class="highlight">${this.inputVal}</span>`)
        },
        clearInputVal() {
            this.inputVal = ''
        },
        handleIndexBarSelect() {
            // const domRef = this.$refs.indexBarRef
            // console.log('🚀 ~ handleIndexBarSelect ~ domRef:', domRef)
            // domRef.scroller.scrollTop -= 66
        },
    },
}
</script>
<style lang="less" scoped>
@import url('~@/assets/css/mixins.less');

.country {
    display: flex;
    flex-direction: column;
    height: 100%;

    .search {
        z-index: 3;
        display: flex;
        flex: 0 0 auto;
        align-items: center;
        width: 100%;
        padding: 18px 16px;
        background: #fff;

        .search-input {
            position: relative;
            display: flex;
            flex: 1 1 auto;
            align-items: center;

            .search-icon {
                position: absolute;
                top: 8px;
                left: 12px;
                width: 16px;
                height: 16px;
            }

            input {
                width: 100%;
                height: 30px;
                padding-left: 36px;
                line-height: 30px;
                background: #f8f8f8;
                border: 0 solid #f8f8f8;
                border-radius: 20px;

                &::placeholder {
                    color: #9c9c9c;
                }
            }

            .clear-icon {
                position: absolute;
                top: 8px;
                right: 12px;
                width: 16px;
                height: 16px;
            }
        }

        .search-cancel {
            margin-left: 16px;
            color: #666;
        }
    }

    .country-box {
        position: relative;
        flex: 1 1 auto;
        overflow: scroll;
        #iosBottom(20px);

        ::v-deep(.van-cell) {
            padding: 16px;

            .van-cell__value {
                padding-right: 16px;
                color: #ff6907;
            }

            .highlight {
                color: #ff6907;
            }
        }

        &.searching {
            ::v-deep {
                .van-cell::before {
                    position: absolute;
                    right: 0.16rem;
                    bottom: 0;
                    left: 0.16rem;
                    box-sizing: border-box;
                    border-bottom: 0.01rem solid #ebedf0;
                    transform: scaleY(0.5);
                    content: ' ';
                    pointer-events: none;
                }

                .van-cell__value {
                    color: #666;
                }
            }
        }
    }
}
</style>
